var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C16.0004 12.6629 15.7374 13.2989 15.269 13.768L9.975 19.061L7.854 16.939L12.793 12L7.854 7.06101L9.975 4.939L15.268 10.232C15.5001 10.4642 15.6843 10.7398 15.8099 11.0432C15.9355 11.3466 16.0001 11.6717 16 12Z",
    fill: "#112348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrowRight);
export default __webpack_public_path__ + "static/media/smallArrowRight.c79add017346287f5eb9972dbb9b099e.svg";
export { ForwardRef as ReactComponent };